import { MdOutlinePets } from "react-icons/md";
import { FaUser } from "react-icons/fa"; 
import { BsFillSendFill, BsCheck } from "react-icons/bs"; 
import { BiPrinter } from "react-icons/bi"; 
import { IoMdInformationCircleOutline } from "react-icons/io"; 
import React from 'react';
import GxForm from '../../gx/GxForm';
import { useTranslation } from '../../hx/useTranslation';
import { useNav } from '../../hx/useNav';
import CxInput from '../../cx/CxInput';
import CxDate from '../../cx/CxDate';
import CxButton from '../../cx/CxButton';
import * as FxLog from '../../fx/FxLog';
import * as FxStr from '../../fx/FxStr';
import { StoreCalendarView, StoreCalendarEvent, StoreComm, StoreClient, clearStore, getStoreValueBo } from "../../gx/GxStore";
import { useSessionStorage } from '../../hx/useSessionStorage';
import CxTime from '../../cx/CxTime';
import CxChooser from '../../cx/CxChooser';
import CxCombo from '../../cx/CxCombo';
import CxMultiCheckNew from '../../cx/CxMultiCheckNew';
import * as FxFetch from '../../fx/FxFetch';
import * as FxArray from '../../fx/FxArray';
import * as FxDat from '../../fx/FxDat';
import CxSnackbar from '../../cx/CxSnackbar';
import CxIconVariant from '../../cx/CxIconVariant';
import { isApp } from '../../gx/GxStore';
import CxBackdrop from '../../cx/CxBackdrop';
import moment from 'moment';
import CxDialog from '../../cx/CxDialog';
import CxIconButton from '../../cx/CxIconButton';
import CxIcon from '../../cx/CxIcon';
import { useAccess } from '../../hx/useAccess';
import { FaSquareFull } from "react-icons/fa";
import CxIconButtonNew from '../../cx/CxIconButtonNew';
import CxAccordion from '../../cx/CxAccordion';
import GxSearcherClient from '../../gx/GxSearcherClient';
import GxSearcherAnimal from '../../gx/GxSearcherAnimal';
import GxIconButtonLastClient2 from '../../gx/GxIconButtonLastClient2';
import GxPrint from '../../gx/GxPrint';


const MxCalendarForm = (props) => {
  const [{ trans }] = useTranslation();
  const [{ isFullAccess }] = useAccess(trans('field.calendar'));
  const [{ navBack, navTo }] = useNav();

  // eslint-disable-next-line no-unused-vars
  const [storeCalendarView, setStoreCalendarView] = useSessionStorage('StoreCalendarView', StoreCalendarView);
  const [storeCalendarEvent, setStoreCalendarEvent] = useSessionStorage('StoreCalendarEvent', StoreCalendarEvent);
  const [storeComm, setStoreComm] = useSessionStorage('StoreComm', StoreComm);
  const [storedClient, setStoreClient] = useSessionStorage('StoreClient', StoreClient);
  const storeClient = storedClient || { ...StoreClient };

  const [, updateState] = React.useState();
  const forceUIUpdate = React.useCallback(() => updateState({}), []);

  const [dlgInfo, setDlgInfo] = React.useState(false);
  const [info, setInfo] = React.useState(null);

  const [dlgDelete, setDlgDelete] = React.useState(false);
  const [backdrop, setBackdrop] = React.useState(false);

  const r_form = React.useRef(null);
  const r_print = React.useRef(null);

  // references to fields
  const r_nuGroup = React.useRef('');
  const rf_date = React.useRef(null);
  const rf_txTypeCalendarCol = React.useRef(null);
  const rf_txTypeCalendarGrp = React.useRef(null);
  const rf_time_start = React.useRef(null);
  const rf_time_end = React.useRef(null);
  const rf_txRemarks = React.useRef(null);
  const rf_txNotes = React.useRef(null);
  const rf_txClient = React.useRef(null);
  const rf_txAnimal = React.useRef(null);

  const r_accordion_repetition = React.useRef(null);
  const rf_repeat_dtFrom = React.useRef(null);
  const rf_repeat_dtTo = React.useRef(null);
  const rf_repeat_txFrequency = React.useRef(null);
  const rf_related_appointments = React.useRef(null);
  const rf_related_appointments_delete = React.useRef(null);

  const r_snack_ask_save = React.useRef(null);
  const r_snack_save = React.useRef(null);
  const r_snack_required = React.useRef(null);
  const r_snack_delete = React.useRef(null);
  const r_snack_overlap = React.useRef(null);
  const r_snack_error = React.useRef(null);


  React.useEffect(() => {
    clearStore('StoreComm', storeComm);

    // 2026-05-04 - daq: Si llega desde el menú limpiamos StoreClient; sino lo dejamos porque se necesita para autoseleccionar cliente.
    if (storeCalendarView.strOrigin !== 'from_animal') {
      clearStore('StoreClient', storeClient); // 2026-05-04 - daq
    }

    formLoadCustom();
    // eslint-disable-next-line
  }, []);

  const formLoadCustom = () => {
    if (!storeCalendarEvent.inCalendar) {
      // EVENTO NUEVO
      // valores predefinidos
      let mDateTime = moment(storeCalendarEvent.dtFrom);
      let theDate = mDateTime.format(moment.HTML5_FMT.DATE);
      let theTimeStart = mDateTime.format(moment.HTML5_FMT.TIME);
      let theTimeEnd = mDateTime.add(storeCalendarView.nuIntervalMins||15, 'minutes').format(moment.HTML5_FMT.TIME);
      rf_date.current.setVal(theDate);
      rf_time_start.current.setVal(theTimeStart);
      rf_time_end.current.setVal(theTimeEnd);
      // columna
      rf_txTypeCalendarCol.current.setVal(storeCalendarEvent.txTypeCalendarCol);
      rf_txTypeCalendarCol.current.setKey(storeCalendarEvent.itCalendarCol);
      // grupo
      rf_txTypeCalendarGrp.current.setKeyAndVal('t_calendar_grp', 'txTypeCalendarGrp', 'itCalendarGrp', '000001.SRV');

      // 2026-05-04 - daq: si viene de la ficha del animal, selecciona automáticamente cliente y animal.
      if (storeCalendarView.strOrigin === 'from_animal') {
        rf_txClient.current.setKey(storeClient.inClient);
        rf_txClient.current.setVal(storeClient.txClient);
        if ((isApp('vett') || isApp('spaw'))) {
          rf_txAnimal.current.setKey(storeClient.inAnimal);
          rf_txAnimal.current.setVal(storeClient.txAnimal);
        }
      }

    } else {
      // EVENTO EXISTENTE
      let record = {};
      record['idValue'] = storeCalendarEvent.inCalendar;
      // enviamos también los settings
      record['boSingleCalendar'] = storeCalendarView.boSingleCalendar;
      record['txWeekDays'] = storeCalendarView.txWeekDays;
      record['txStartHour'] = storeCalendarView.txStartHour;
      record['txWorkTime1From'] = storeCalendarView.txWorkTime1From;
      record['txWorkTime1To'] = storeCalendarView.txWorkTime1To;
      record['txWorkTime2From'] = storeCalendarView.txWorkTime2From;
      record['txWorkTime2To'] = storeCalendarView.txWorkTime2To;

      Promise.all([FxFetch.doJsonX("cal/r", record)]).then((result) => {
        if (result[0]) {
          // guardamos cliente y paciente en store
          storeClient.inClient = result[0][0].inClient;
          storeClient.txClient = result[0][0].txClient;
          if ((isApp('vett') || isApp('spaw'))) {
            storeClient.inAnimal = result[0][0].inAnimal;
            storeClient.txAnimal = result[0][0].txAnimal;
          }
          setStoreClient(storeClient);

          let theDate = result[0][0].dtFrom.substring(0, 10);
          let dtFrom = result[0][0].dtFrom;
          let dtTo = result[0][0].dtTo;
          if (dtFrom !== null) {
            dtFrom = dtFrom.substring(11, 16);
          }
          if (dtTo !== null) {
            dtTo = dtTo.substring(11, 16);
          }
          rf_date.current.setVal(theDate);
          rf_txTypeCalendarCol.current.setVal(result[0][0].txTypeCalendarCol);
          rf_txTypeCalendarCol.current.setKey(result[0][0].itCalendarCol);
          rf_txTypeCalendarGrp.current.setVal(result[0][0].txTypeCalendarGrp);
          rf_txTypeCalendarGrp.current.setKey(result[0][0].itCalendarGrp);
          rf_time_start.current.setVal(dtFrom);
          rf_time_end.current.setVal(dtTo);
          rf_txRemarks.current.setVal(result[0][0].txRemarks)
          rf_txNotes.current.setVal(result[0][0].txNotes)
          rf_txClient.current.setKey(result[0][0].inClient);
          rf_txClient.current.setVal(result[0][0].txClient);
          if ((isApp('vett') || isApp('spaw'))) {
            rf_txAnimal.current.setKey(result[0][0].inAnimal);
            rf_txAnimal.current.setVal(result[0][0].txAnimal);
          }

          r_nuGroup.current = result[0][0].nuGroup;
          refreshRelatedAppointments();
        }
      });
    }
  };
  
  const refreshRelatedAppointments = () => {
    setRelatedAppointments("n_calendar", "inCalendar", "dtFrom",`nuGroup='${r_nuGroup.current}' and inCalendar<>'${storeCalendarEvent.inCalendar}'`);
  }

  const setRelatedAppointments = async (tableName, idField, txField, txExtraFilter1) => {
    let record = {};
    record['pageNo'] = '0';
    record['pageSize'] = '1000';
    record['sortBy'] = idField;
    record['filter'] = '';
    record['tableName'] = tableName;
    record['idField'] = idField;
    record['idFieldAlias'] = "id";
    record['txField'] = txField;
    record['txFieldAlias'] = 'name';
    record['txExtraFilter1'] = txExtraFilter1;

    try {
      const result = await FxFetch.doJsonX('general/page', record);
      if (result) {
        let ls = FxArray.sortArrayByField(result, 'name', 'asc');
        FxLog.infox('MxCalendarForm.setRelatedAppointments', '...ls:', ls);

        const formattedList = ls.map(item => {
          FxLog.infox('MxCalendarForm.setRelatedAppointments', '...txField:', txField);
          FxLog.infox('MxCalendarForm.setRelatedAppointments', '...item[name]:', item['name']);
          let formattedValue = '';
          switch (true) { // 'true' permite usar condiciones complejas en los 'case'
            case txField.startsWith('dt'):
              formattedValue = FxDat.toLocalDateTime(item['name']);
              break;

            case txField.startsWith('nu'):
              formattedValue = item['name'];
              break;

            default:
              formattedValue = item['name'];
              break;
          }
          return { ...item, name: formattedValue };
        });
        await rf_related_appointments.current.setList(formattedList);

        let hasItems = formattedList.length>0;
        rf_repeat_txFrequency.current.setVisible(!hasItems);
        rf_repeat_dtFrom.current.setVisible(!hasItems);
        rf_repeat_dtTo.current.setVisible(!hasItems);
        rf_related_appointments.current.setVisible(hasItems);
        rf_related_appointments_delete.current.setVisible(hasItems);

      }

    } catch (error) {
      console.error("Detalles del error al obtener datos generales:", error);
      FxLog.errorx('MxCalendarForm.getValuesFromDb_General', 'Error fetching data:', error);
    }
  }

  const formDeleteCustom = () => {
    setDlgDelete(true);
  }
  const doDelete = () => {
    if (storeCalendarEvent.inCalendar) {
      setBackdrop(true);
      let url = "cal/d";
      let record = {};
      record['idValue'] = storeCalendarEvent.inCalendar;
      // enviamos también los settings
      record['boSingleCalendar'] = storeCalendarView.boSingleCalendar;
      record['txWeekDays'] = storeCalendarView.txWeekDays;
      record['txStartHour'] = storeCalendarView.txStartHour;
      record['txWorkTime1From'] = storeCalendarView.txWorkTime1From;
      record['txWorkTime1To'] = storeCalendarView.txWorkTime1To;
      record['txWorkTime2From'] = storeCalendarView.txWorkTime2From;
      record['txWorkTime2To'] = storeCalendarView.txWorkTime2To;
      Promise.all([FxFetch.doJsonX(url, record)]).then((result) => {
        if (result[0]) {
        } else {
        }
        r_snack_delete.current.setOpen(true);
      });
    }
  };

  const formSaveCustom = () => {
    if (!isRequired()) {

      // Validación: hora Hasta > hora Desde
      const timeFrom = rf_time_start.current.getVal();
      const timeTo = rf_time_end.current.getVal();

      if (timeFrom && timeTo) {
        const fromMoment = moment(timeFrom, 'HH:mm');
        const toMoment = moment(timeTo, 'HH:mm');
        if (!toMoment.isAfter(fromMoment)) {
          r_snack_required.current.setVal(trans('msg.start_must_be_before_end'));
          r_snack_required.current.setOpen(true);
          return;
        }
      }

      FxLog.infox('MxCalendarForm.formSaveCustom', '...saving');
      // guardamos cliente y paciente en store
      storeClient.inClient = rf_txClient.current.getKey();
      storeClient.txClient = rf_txClient.current.getVal();
      if ((isApp('vett') || isApp('spaw'))) {
        storeClient.inAnimal = rf_txAnimal.current.getKey();
        storeClient.txAnimal = rf_txAnimal.current.getVal();
      }
      setStoreClient(storeClient);

      // guardamos evento en db
      let filter = { "inCalendar": storeCalendarEvent.inCalendar, };
      let record = {};
      record['t_calendar_col.txTypeCalendarCol'] = rf_txTypeCalendarCol.current.getVal();
      record['n_calendar.itCalendarCol'] = rf_txTypeCalendarCol.current.getKey();
      record['t_calendar_grp.txTypeCalendarGrp'] = rf_txTypeCalendarGrp.current.getVal();
      record['n_calendar.itCalendarGrp'] = rf_txTypeCalendarGrp.current.getKey();
      record['n_calendar.inClient'] = rf_txClient.current.getKey();
      record['n_calendar.dtFrom'] = `${rf_date.current.getVal()} ${rf_time_start.current.getVal()}:00`;
      record['n_calendar.dtTo'] = `${rf_date.current.getVal()} ${rf_time_end.current.getVal()}:00`;
      record['n_calendar.txRemarks'] = rf_txRemarks.current.getVal();
      record['n_calendar.txNotes'] = rf_txNotes.current.getVal();
      // enviamos también los settings
      record['boSingleCalendar'] = storeCalendarView.boSingleCalendar;
      record['txWeekDays'] = storeCalendarView.txWeekDays;
      record['txStartHour'] = storeCalendarView.txStartHour;
      record['txWorkTime1From'] = storeCalendarView.txWorkTime1From;
      record['txWorkTime1To'] = storeCalendarView.txWorkTime1To;
      record['txWorkTime2From'] = storeCalendarView.txWorkTime2From;
      record['txWorkTime2To'] = storeCalendarView.txWorkTime2To;

      if ((isApp('vett') || isApp('spaw'))) {
        record['n_calendar.inAnimal'] = rf_txAnimal.current.getKey();
      }

      //setBackdrop(true);
      Promise.all([FxFetch.doJsonF("cal/cu", filter, record)]).then((result) => {
        //setBackdrop(false);
        if (result[0]) {
          if (result[0].theValue === 'rv_overlap') {
            r_snack_overlap.current.setOpen(true);
            return;
          }
          if (result[0].theValue === 'rv_error' || !result[0].theValue) {
            r_snack_error.current.setValAndOpen(trans('msg.operation_failed'));
            return;
          }
          storeCalendarEvent.inCalendar = result[0].theValue;
          setStoreCalendarEvent(storeCalendarEvent);
          Promise.all([doRepeat()]).then((result) => {
            FxLog.infox('MxCalendarForm.formSaveCustom', '...result:', result);
            if (result[0]==='OK') {
              r_accordion_repetition.current.setVisible('true');
              rf_repeat_txFrequency.current.setVisible('true');
              rf_repeat_dtFrom.current.setVisible('true');
              rf_repeat_dtTo.current.setVisible('true');
              r_snack_save.current.setOpen(true);
            }
            forceUIUpdate();
          });
        }
      });
    }
  };
  
  const doRepeat = async () => {
    if (rf_repeat_dtFrom.current.isEmpty() || rf_repeat_dtFrom.current.isEmpty()) {
      return 'OK';
    }
    setBackdrop(true); // 2025-10-23 - daq: OJO, si son muchos eventos, puede dar timeout. Habría que mejorar el backend.
    let record = {};
    record['inCalendar'] = storeCalendarEvent.inCalendar; // evento original
    record['dtRepeatFrom'] = rf_repeat_dtFrom.current.getVal();
    record['dtRepeatTo'] = rf_repeat_dtTo.current.getVal();
    record['txFrequency'] = rf_repeat_txFrequency.current.getKey();
    record['dtFrom'] = `${rf_date.current.getVal()} ${rf_time_start.current.getVal()}`;
    record['dtTo'] = `${rf_date.current.getVal()} ${rf_time_end.current.getVal()}`;
    record['txTypeCalendarGrp'] = rf_txTypeCalendarGrp.current.getVal();
    record['itCalendarGrp'] = rf_txTypeCalendarGrp.current.getKey();
    record['itCalendarCol'] = rf_txTypeCalendarCol.current.getKey();
    record['inClient'] = rf_txClient.current.getKey();
    record['inAnimal'] = rf_txAnimal.current.getKey();
    record['txRemarks'] = rf_txRemarks.current.getVal();
    record['txNotes'] = rf_txNotes.current.getVal();
    return Promise.all([FxFetch.doJsonF("cal/repeat", null, record)]).then((result) => {
      rf_related_appointments.current.setList([]);
      setBackdrop(false);
      if (result[0]) {
        if (result[0].theStatus === 'error') {
          return  'NOK';
        }
        if (result[0].theStatus === 'OK') {
          r_nuGroup.current = result[0].theValue.split('|')[1];
          refreshRelatedAppointments();
          return 'OK';
        }
      }
    });
  }

  const doDeleteRelatedAppointments = () => {
    let checkedIds = rf_related_appointments.current.getVal();
    if (checkedIds) {
      let record = {};
      record['idValue'] = checkedIds;
      setBackdrop(true);
      Promise.all([FxFetch.doJsonX('cal/d', record)]).then((result) => {
        rf_related_appointments.current.setList([]);
        setBackdrop(false);
        if (result[0]) {
          refreshRelatedAppointments();
          if (result[0].theValue === 'OK') {
          }
        }
      });
    }
  }

  const isRequired = () => {
    let rv = false;
    let cc = [rf_txTypeCalendarCol, rf_txTypeCalendarGrp, rf_date, rf_time_start, rf_time_end, rf_txRemarks];
    cc.reverse().forEach((c, index) => {
      if (c.current.getIsRequired()) {
        let label = c.current.getLabel();
        r_snack_required.current.setVal(trans('field.required') + ": " + label);
        r_snack_required.current.setOpen(true);
        rv = true;
      }
    });
    return rv;
  };

  const doInfo = () => {
    let inClient = rf_txClient.current.getKey();
    if (inClient) {
      let record = {};
      record['idValue'] = inClient;
      Promise.all([FxFetch.doJsonF("clients/r", null, record)]).then((result) => {
        if (result[0]) {
          setInfo(result[0][0]);
          setDlgInfo(true);
        }
      });
    } else {
      r_snack_error.current.setVal(trans('msg.select_x', 'field.client'));
      r_snack_error.current.setOpen(true);
    }
  }

  const doPrint = () => {
    let inCalendar = storeCalendarEvent.inCalendar;
    let inClient = rf_txClient.current.getKey();
    if (inCalendar) {
      if (inClient) {
        let filter = {};
        filter['reportFormat'] = `PDF`;
        filter['inCalendar'] = inCalendar;
        let record = {};
        r_print.current.setScale(1.5);
        r_print.current.setUrl('cal/report/appt');
        //----------------
        Promise.all([
          r_print.current.setFilter(filter),
          r_print.current.setRecord(record),
          r_print.current.setInClient(inClient),
        ]).then((result) => {
          r_print.current.doPrint();
        });

      } else {
        r_snack_error.current.setVal(trans('msg.select_x', 'field.client'));
        r_snack_error.current.setOpen(true);
      }

    } else {
      r_snack_ask_save.current.setOpen(true);
    }
  }

  const openFormComm = () => {
    if (storeCalendarEvent.inCalendar) {
      let record = {};
      record['inCalendar'] = storeCalendarEvent.inCalendar;
      Promise.all([FxFetch.doJsonX('comms/get_inComm_from_inCalendar', record)]).then((result) => {
        if (result[0]) {
          if (result[0].theValue) {
            // ya hay una comunicación para este evento-calendario, así que la cargamos
            storeComm.inComm = result[0].theValue;
          } else {
            // no hay una comunicación, así que preparamos form para crear una nueva
            storeComm.inComm = null;
            storeComm.inCalendar = storeCalendarEvent.inCalendar;
            storeComm.inClient = rf_txClient.current.getKey();
            if ((isApp('vett') || isApp('spaw'))) {
              storeComm.inAnimal = rf_txAnimal.current.getKey();
            }
            storeComm.dtFrom = `${rf_date.current.getVal()} ${rf_time_start.current.getVal()}`;
          }
          setStoreComm(storeComm);
          navTo("comm-form");
        }
      });

    } else {
      r_snack_ask_save.current.setOpen(true);
    }
  }

  const openFormClient = () => {
    if (!storeClient.inClient) {
      r_snack_error.current.setValAndOpen(trans('msg.save_x_before', 'field.client'));
      return;
    }

    // Actualizar el store con los valores actuales del formulario
    storeClient.inClient = rf_txClient.current.getKey();
    storeClient.txClient = rf_txClient.current.getVal();
    setStoreClient(storeClient);

    // Abrir en nueva pestaña si el sistema está disponible, o navegar
    // directamente como fallback (móvil / pestañas desactivadas).
    if (getStoreValueBo('StoreSession', 'boShowTabs')) {
      window.__mxMain_openTabWithNavigation('client-form', storeClient.txClient || trans('field.client'), false);
    } else {
      navTo('client-form');
    }
  };

  const openFormAnimal = () => {
    if (!storeClient.inAnimal) {
      r_snack_error.current.setValAndOpen(trans('msg.save_x_before', 'field.patient'));
    } else {
      storeClient.inClient = rf_txClient.current.getKey();
      storeClient.txClient = rf_txClient.current.getVal();
      storeClient.inAnimal = rf_txAnimal.current.getKey();
      storeClient.txAnimal = rf_txAnimal.current.getVal();
      setStoreClient(storeClient);

      // Abrir en nueva pestaña si el sistema está disponible, o navegar
      // directamente como fallback (móvil / pestañas desactivadas).
      if (getStoreValueBo('StoreSession', 'boShowTabs')) {
        window.__mxMain_openTabWithNavigation('animal-form', storeClient.txAnimal || trans('field.patient'), false);
      } else {
        navTo('animal-form');
      }
    }
  }

  return (
    <div>
      <GxForm
        moduleName={`${trans('field.calendar')}: ${trans('field.event')}`}
        xref={r_form}
        addToolbarButtons={
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <CxIconButtonNew icon={<IoMdInformationCircleOutline fontSize={23} style={{marginTop:'1px'}} />} classType="ibs_iconbutton_toolbar" onClick={() => doInfo()} tooltip={trans('field.additional_information')} />
            {storeCalendarEvent.inCalendar && <CxIconButtonNew icon={<BiPrinter fontSize={23} />} classType="ibs_iconbutton_toolbar" onClick={() => doPrint()} tooltip={trans('rpt.cal_appt')} />}
            
            {storeCalendarEvent.inCalendar && isFullAccess() && (
              <CxIconButtonNew 
                icon={
                  <CxIcon 
                    frontIcon={(storeCalendarEvent.boComm) ? <BsCheck /> : null} 
                    frontSize="12px"
                    frontPos={{ bottom: "-2px", right: "-2px" }}
                    frontShell="circle"
                    frontShellColor="yellow"
                    frontColor="var(--ibs_color_black_dark)"
                    backIcon={<BsFillSendFill />} 
                    backSize="20px"
                    backColor="var(--ibs_color_cy_blue)"
                  />
                } 
                classType="ibs_iconbutton_toolbar" 
                onClick={openFormComm} 
                tooltip={trans('field.comm')} 
              />
            )}

            <GxIconButtonLastClient2 theClient={rf_txClient} theAnimal={rf_txAnimal} />

            {storeCalendarEvent.inCalendar && <CxIconButtonNew 
              icon={getStoreValueBo('StoreSession', 'boShowTabs') ? (<CxIconVariant variant="client-go" />) : (<FaUser fontSize={19} style={{ margin: '2px 0 0 0px' }} />)} 
              classType="ibs_iconbutton_toolbar" onClick={openFormClient} tooltip={trans('field.open_x', 'field.client')} 
            />}

            {storeCalendarEvent.inCalendar && (isApp('vett') || isApp('spaw')) && <CxIconButtonNew 
              icon={getStoreValueBo('StoreSession', 'boShowTabs') ? (<CxIconVariant variant="animal-go" />) : (<MdOutlinePets fontSize={22} style={{ margin: '0px 0 0 0px' }} />)} 
              classType="ibs_iconbutton_toolbar" 
              onClick={openFormAnimal} 
              tooltip={trans('field.open_x', 'field.patient')} 
            />}

            {storeCalendarEvent.inCalendar && isFullAccess() && <CxIconButton type="delete" classType="ibs_iconbutton_toolbar" onClick={() => formDeleteCustom()} />}
            {isFullAccess() && <CxIconButton type="save" classType="ibs_iconbutton_toolbar" onClick={() => formSaveCustom()} />}
          </div>
        }
      >
        <CxDate xref={rf_date} label={trans('field.date')} required />
        <CxTime xref={rf_time_start} label={trans('field.from')} required />
        <CxTime xref={rf_time_end} label={trans('field.to')} required />

        <CxChooser xref={rf_txTypeCalendarCol} label={trans('field.column')}
          dbfield="t_calendar_col.txTypeCalendarCol" dbfieldkey={`n_calendar.itCalendarCol`}
          table="t_calendar_col"
          col_id="itCalendarCol"
          col_tx="txTypeCalendarCol"
          bottomLegend={`${trans('msg.setup_new_1')}: ${trans('field.settings')} > ${trans('field.options')} > ${trans('field.calendars')} > ${trans('field.columns')}`}
          required
        />

        <CxChooser xref={rf_txTypeCalendarGrp} label={trans('msg.select_x', 'field.group')}
          dbfield="t_calendar_grp.txTypeCalendarGrp" dbfieldkey={`n_calendar.itCalendarGrp`}
          table="t_calendar_grp"
          col_id="itCalendarGrp"
          col_tx="txTypeCalendarGrp"
          extra_column_field_1="txRgb"
          extra_column_value_1={{
            id: "2", Header: trans('field.color'), accessor: row => {
              return <CxIconButtonNew icon={<FaSquareFull fontSize="20px" style={{ color: FxStr.rgb2hex(row["txRgb"]), border: '1px solid gray' }} />} />
            }, width: '20%', align: 'center'
          }}
          bottomLegend={`${trans('msg.setup_new_1')}: ${trans('field.settings')} > ${trans('field.options')} > ${trans('field.calendars')} > ${trans('field.groups')}`}
          required
        />

        <CxInput xref={rf_txRemarks} label={trans('field.event')} maxLength={150} speech required />

        <GxSearcherClient xref={rf_txClient} animalRef={rf_txAnimal} />
        {(isApp('vett') || isApp('spaw')) && <GxSearcherAnimal xref={rf_txAnimal} clientRef={rf_txClient} />}

        <CxInput xref={rf_txNotes} label={trans('field.notes')} minRows={6} speech />

        <CxAccordion xref={r_accordion_repetition} 
          title={trans('field.repetition')} 
          background={"var(--ibs_color_gray_light)"} 
          color={"var(--ibs_color_black)"} 
          visible={storeCalendarEvent.inCalendar ? 'true' : 'false'}
          defaultExpanded 
        >

          <CxCombo xref={rf_repeat_txFrequency}
            label={`${trans('field.frequency')}`}
            list={[
              { id: 'd', type: trans('field.daily_events') },
              { id: 'w', type: trans('field.weekly_events') },
              { id: 'm', type: trans('field.monthly_events') },
              { id: 'q', type: trans('field.quarterly_events') },
              { id: 'a', type: trans('field.annual_events') },
            ]}
            clearDisabled
            visible='false'
            defaultValue="d"
          />

          <CxDate xref={rf_repeat_dtFrom} label={trans('field.from')} visible='false' />

          <CxDate xref={rf_repeat_dtTo} label={trans('field.to')} visible='false' />

          <CxMultiCheckNew mode='checkbox' xref={rf_related_appointments}
            label={trans('field.related_x_0', 'field.appointments')}
            minRows={4}
            itemWidth="150px"
            visible='false'
          />

          <CxButton xref={rf_related_appointments_delete} label={trans('field.delete')} 
            style={{ margin: '5px 0 0 0' }} 
            onClick={doDeleteRelatedAppointments} 
            visible='false'
          />
          
        </CxAccordion>

      </GxForm>

      <CxSnackbar xref={r_snack_required} severity="error" />
      <CxSnackbar xref={r_snack_save} severity="success" value={trans('msg.saved')} /* onClose={() => navBack()} no salimos xq puede querer guardar un recordatorio */ />
      <CxSnackbar xref={r_snack_delete} severity="success" value={trans('msg.deleted')} onClose={() => navBack()} />
      <CxSnackbar xref={r_snack_overlap} severity="error" value={trans('msg.time_overlap')} />

      <CxDialog title={trans('field.information')} open={dlgInfo}
        onOk={() => setDlgInfo(false)}
        width='400px' height='400px'>
        {info && <div style={{ width: '250px', }}>
          {info.txMobile && <div>
            <p style={{ height: '5px', fontSize: '12px' }}>{trans('field.mobile') + ":"}</p>
            <p><a href={`tel:${info.txMobile}`}><b>{info.txMobile}</b></a></p>
          </div>}
          {info.txPhone1 && <div>
            <p style={{ height: '5px', fontSize: '12px' }}>{trans('field.phone1') + ":"}</p>
            <p><a href={`tel:${info.txPhone1}`}><b>{info.txPhone1}</b></a></p>
          </div>}
          {info.txPhone2 && <div>
            <p style={{ height: '5px', fontSize: '12px' }}>{trans('field.phone2') + ":"}</p>
            <p><a href={`tel:${info.txPhone2}`}><b>{info.txPhone2}</b></a></p>
          </div>}
          {info.txEmail && <div>
            <p style={{ height: '5px', fontSize: '12px' }}>{trans('field.email') + ":"}</p>
            <p><a href={`mailto:${info.txEmail}`}><b>{info.txEmail}</b></a></p>
          </div>}
        </div>}
      </CxDialog>


      <CxDialog title={trans('msg.warning')} open={dlgDelete}
        onCancel={() => setDlgDelete(false)}
        onOk={() => { setDlgDelete(false); doDelete() }}
        height='200px'>
        {trans('msg.ask_delete')}
      </CxDialog>

      <CxSnackbar xref={r_snack_ask_save} severity="error" value={trans('msg.save_before')} />
      <CxSnackbar xref={r_snack_error} severity="error" />

      <GxPrint xref={r_print} />

      <CxBackdrop open={backdrop} />
    </div>
  );

}

export default MxCalendarForm;
